<template>
     <button>
      <img src="/images/google.svg" alt="" />
      Sign up with Google
    </button>
</template>

<style scoped>
button {
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background: #f1f1f1;
  padding: 9px 12px;

  display: flex;
  justify-content: start;
  align-items: center;
  gap: 20px
}
</style>